"use strict";

var _slicedToArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileInputAws = void 0;

var tslib_1 = require("tslib"); // @ts-nocheck


var react_1 = tslib_1.__importStar(require("react"));

var components_1 = require("./components");

var hooks_1 = require("./hooks");

var UNSUPPORTED_OPTIONS = ['allowManualRetry', 'fromSources', 'container', 'cleanupImageExif', 'customAuthText', 'displayMode', 'customSourceContainer', 'customSourcePath', 'customSourceName', 'customText', 'disableStorageKey', 'disableTransformer', 'disableThumbnails', 'dropPane', 'exposeOriginalFile', 'globalDropZone', 'hideModalWhenUploading', 'imageDim', 'imageMax', 'imageMin', 'lang', 'viewType', 'errorsTimeout', 'modalSize', 'rootId', 'startUploadingWhenMaxFilesReached', 'storeTo', 'transformations', 'uploadConfig', 'uploadInBackground', 'videoResolution', 'minFiles'];

var warnAboutOptions = function warnAboutOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if ('maxFiles' in options) {
    console.warn('@8base-react/file-input: Specify "maxFiles" as a prop for FileInput component');
  }

  if ('onUploadDone' in options) {
    console.warn('@8base-react/file-input: Specify "onUploadDone" as a prop for FileInput component');
  }

  setTimeout(function () {
    UNSUPPORTED_OPTIONS.forEach(function (optionKey) {
      if (optionKey in options) {
        console.warn("@8base-react/file-input: ".concat(optionKey, " option is not supported yet"));
      }
    });
  }, 0);
};

var FileInputAws = function FileInputAws(_ref) {
  var children = _ref.children,
      maxFiles = _ref.maxFiles,
      accept = _ref.accept,
      fallbackOptions = _ref.fallbackOptions,
      _ref$value = _ref.value,
      controlledValue = _ref$value === void 0 ? null : _ref$value,
      uploadCallback = _ref.onUploadDone,
      onChange = _ref.onChange,
      _ref$useFilestack = _ref.useFilestack,
      useFilestack = _ref$useFilestack === void 0 ? false : _ref$useFilestack,
      workspace = _ref.workspace,
      apiKey = _ref.apiKey,
      uploadHost = _ref.uploadHost,
      environment = _ref.environment;

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      calledFallback = _ref3[0],
      setCalledFallback = _ref3[1];

  var _ref4 = (0, hooks_1.useFilePicker)({
    uploadCallback: uploadCallback,
    controlledValue: controlledValue,
    onChange: onChange
  }),
      fileList = _ref4.fileList,
      fileProgressList = _ref4.fileProgressList,
      isOpen = _ref4.isOpen,
      hideFilePicker = _ref4.hideFilePicker,
      showFilePicker = _ref4.showFilePicker,
      addFiles = _ref4.addFiles,
      removeFile = _ref4.removeFile,
      step = _ref4.step,
      setUploadMoreStep = _ref4.setUploadMoreStep,
      setUploadStep = _ref4.setUploadStep,
      upload = _ref4.upload,
      getRootProps = _ref4.getRootProps,
      getInputProps = _ref4.getInputProps,
      options = _ref4.options,
      value = _ref4.value,
      originalFile = _ref4.originalFile,
      error = _ref4.error;

  var pick = (0, react_1.useCallback)(function () {
    var pickerOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    warnAboutOptions(options);
    showFilePicker(Object.assign(Object.assign({}, pickerOptions), {
      maxFiles: maxFiles,
      accept: accept
    }));
  }, [showFilePicker, maxFiles, options, accept]);
  (0, react_1.useEffect)(function () {
    if (calledFallback) {
      return;
    }

    if (fallbackOptions) {
      pick(fallbackOptions);
    }

    setCalledFallback(true);
  }, [fallbackOptions, calledFallback, pick]);

  var handleAWSUpload = function handleAWSUpload() {
    // eslint-disable-next-line no-console
    //console.log(useFilestack, workspace, apiKey, uploadHost, environment);
    upload(useFilestack, workspace, apiKey, uploadHost, environment);
  };

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(components_1.Modal, {
    isOpen: isOpen || !!error,
    onClose: hideFilePicker
  }, react_1.default.createElement(components_1.FilePickerContent, {
    step: step,
    hideFilePicker: hideFilePicker,
    addFiles: addFiles,
    fileList: fileList,
    setUploadStep: setUploadStep,
    removeFile: removeFile,
    setUploadMoreStep: setUploadMoreStep,
    upload: handleAWSUpload,
    fileProgressList: fileProgressList,
    getInputProps: getInputProps,
    getRootProps: getRootProps,
    errorMessage: error,
    options: options
  })), children({
    pick: pick,
    value: value,
    originalFile: originalFile,
    error: error
  }));
};

exports.FileInputAws = FileInputAws;